import React, { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Outlet } from 'react-router-dom'

import { getPathFromPageId } from '~/shared/helpers/getPathFromPageId'
import {
  selectCohortID,
  selectCurrentVariantSteps,
} from '~/shared/store/common/selects'
import { selectUserUUID } from '~/shared/store/user/selects'
import { appHistory } from '~/shared/utils'

export const OnboardingLayout: FC = () => {
  const { search } = useLocation()

  const steps = useSelector(selectCurrentVariantSteps)
  const cohort = useSelector(selectCohortID)
  const uuid = useSelector(selectUserUUID)

  const firstPagePath = getPathFromPageId({
    pageId: steps[0].id,
    cohort,
    uuid,
    currentSearch: search,
  })

  useEffect(() => {
    const URLParams = new URLSearchParams(search)
    const uuidFromUrl = URLParams.get('uuid')

    if (!uuidFromUrl) {
      appHistory.goTo(firstPagePath)
    }
  }, [search, firstPagePath])

  return <Outlet />
}
